import _ from 'lodash';
import { SelectionAreaWrapper } from '@/shared/ui';
import { ID_DIV_DEVICE_STRIP_MANAGEMENT } from '@/widgets/strips-management/ui/handler';
import DeviceEventPreviewStrip from './deviceEventPreviewStrip';
import useDeviceStripEvents from './useDeviceStripEvents';

export type DeviceStripEventsProps = {
  keyRecoil: any;
  activeButton?: any;
  studyId?: any;
  reportData?: any;
  isActive?: boolean;
};

/**
 * Grid of device event strip thumbnails supporting drag-rectangle multi-selection. useDeviceStripEvents provides the strips, the loading flag, the current single and multiple selection and the thumbnail size config, which the selection-area wrapper uses to drive empty, loading and reset states while each strip renders as a preview thumbnail marked active or selected.
 *
 * @param props - Grid props carrying the tab key, study id, report data, active button and tab-active flag.
 * @returns The rendered selectable grid of device event thumbnails.
 */
const DeviceStripEvents = ({
  keyRecoil,
  activeButton,
  studyId,
  reportData,
  isActive,
}: DeviceStripEventsProps) => {
  const {
    selectionAreaWrapperRef,
    setSelectedEvent,
    selectedStrip,
    eventStrips,
    isLoadingStrip,
    selectedMultipleStrip,
    sizeThumbnailConfig,
    handleClickSelectEvent,
  } = useDeviceStripEvents({ keyRecoil, activeButton, studyId, reportData, isActive });

  return (
    <SelectionAreaWrapper
      ref={selectionAreaWrapperRef}
      id={ID_DIV_DEVICE_STRIP_MANAGEMENT}
      className="strips-container --min-width-strip-event"
      selectables=".single-strip-management-event"
      handleSetSelected={setSelectedEvent}
      defaultSelectedId={selectedStrip?.id as any}
      isNoData={eventStrips?.length === 0}
      isLoading={isLoadingStrip}
      couldForceReset
      isEmptySelected={_.isEmpty(selectedMultipleStrip)}
    >
      {(selected) => (
        <div className="strips-img-container">
          {_.map(eventStrips, (strip, index) => (
            <DeviceEventPreviewStrip
              key={strip.id}
              index={index}
              id={`beat-${strip.id}`}
              isActive={strip.id === selectedStrip?.id}
              isSelected={selected.has(`beat-${strip.id}`)}
              event={strip}
              sizeThumbnailConfig={sizeThumbnailConfig}
              onClickSelectEvent={handleClickSelectEvent}
            />
          ))}
        </div>
      )}
    </SelectionAreaWrapper>
  );
};

export default DeviceStripEvents;
